import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './PostalCodeEditor.html?raw';
import MainCatalogsEditorBaseV2 from '../MainCatalogsEditorBaseV2';
import { MainCatalogs_Classes, MainCatalogTypes } from "../../_loadingHelpers/MainCatalogTypes";
import Edit from '../../../moreCore/UI/Edit/Edit';
import HintBox from '../../../moreCore/UI/HintBox/HintBox';
import CheckBox from '../../../moreCore/UI/CheckBox/CheckBox';

class PostalCodeEditor extends compose(MainCatalogsEditorBaseV2) {
    templateString: any = template;

    private inputPostalCode: MdsLax<InstanceType<typeof Edit>>;
    private inputCity: MdsLax<InstanceType<typeof Edit>>;
    private inputState: MdsLax<InstanceType<typeof HintBox>>;
    private inputCountry: MdsLax<InstanceType<typeof HintBox>>;
    private inputIsBorough: MdsLax<InstanceType<typeof CheckBox>>;
    private inputAreaDialingCode: MdsLax<InstanceType<typeof Edit>>;

    private _onChangeState(e) {
        var state = this.inputState.getValue("entity");
        if (state) {
            this.inputCountry.setValue(state.ref_country);
            this.disableNode(this.inputCountry, true);
        } else {
            this.disableNode(this.inputCountry, false);
            this.inputCountry.setValue(null);
        }
    }

    afterSetData(): void {
        super.afterSetData.apply(this, arguments as any);

        this._onChangeState(null);
    }

    isValid(): boolean {
        return true;
    }

    protected _setEntityClass(): void {
        this.entityClass = MainCatalogs_Classes.PostalCodes;
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.inputAreaDialingCode.setInputType("number");

    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(PostalCodeEditor);